<ion-app>
  <ion-split-pane contentId="main-content">

    <ion-menu contentId="main-content">
      <ion-content style="background-image: url('../assets/img/Group 436.png'); background-repeat: no-repeat; background-size: cover;">

        <ion-list lines="none">

          <ion-list-header>
            {{content?.menuTitle}}
          </ion-list-header>

          <ion-menu-toggle autoHide="false" *ngFor="let p of appPages; let i = index">
            <ion-item [routerLink]="p.url" (click)="analyticsEvent('navigation', 'mobile menu', 'click', 1,  p.url)"
              routerLinkActive="selected" routerDirection="root" detail="false">
              <ion-icon slot="start" [name]="p.icon + '-outline'" ariaLabel=" "></ion-icon>
              <ion-label>
                {{p.title}}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle autoHide="false">
            <ion-item button (click)="logout()" detail="false">
              <ion-icon slot="start" name="log-out" ariaLabel=" "></ion-icon>
              <ion-label>
                {{content?.menuSignOut}}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>

        </ion-list>

          <div style="position: absolute; bottom: 10px; width: 100%;" (click)="presentModal()">
            <img style="width: 100%;" src="../assets/img/Group 435.png" alt="">
          </div>
        
      </ion-content>

      <ion-footer class="sidemenu-footer ion-text-center">
        <ion-toolbar color="primary">
          <div routerLink="/test" class="copyright">©2020 Publicis Sapient (version: {{ version }})</div>
        </ion-toolbar>
      </ion-footer>

    </ion-menu>

    <ion-router-outlet id="main-content"></ion-router-outlet>

  </ion-split-pane>

</ion-app>
<app-alert></app-alert>